import ThisModule from "./ModalCancelPurchase";

export default ThisModule;
